
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabandbusservicepuneranjangaon() {



    const cardData =
    {
        keyword: 'Corporate Cabs and Bus in Ranjangaon MIDC',
        heading: 'etravo : Corporate Cabs and Bus in Ranjangaon MIDC ',
        headingDescription: 'eTravo delivers professional Corporate Cab and Bus Services in Ranjangaon MIDC, tailored to meet the transportation demands of manufacturing plants, factories, and corporate offices. Whether you require executive cabs for business travel or large-capacity buses for daily employee commutes and shift transport, we ensure timely, safe, and efficient service. Our fleet is GPS-enabled, well-maintained, and operated by trained drivers, offering seamless mobility solutions that help your operations run smoothly in the Ranjangaon MIDC region.',

        top: 'Top Places to Visit in Ranjangaon with etravo',
      "topPlaces": [
    {
      "title": "Shree Mahaganapati Temple",
      "description": "One of the eight revered Ashtavinayak temples dedicated to Lord Ganesha, the Shree Mahaganapati Temple in Ranjangaon is renowned for its spiritual significance and architectural beauty. The temple features a grand entrance and houses an idol of Lord Ganesha known as 'Mahotkat', believed to have 10 trunks and 20 arms. The temple is designed so that during the Dakshinayan period, the sun's rays fall directly on the deity. It is a major pilgrimage site, especially during Ganesh Chaturthi."
    },
    {
      "title": "Bhuleshwar Temple",
      "description": "Located approximately 25 km from Ranjangaon, Bhuleshwar Temple is an ancient temple dedicated to Lord Shiva. Perched atop a hill, it offers panoramic views of the surrounding landscape. The temple is known for its unique architecture and intricate carvings, making it a significant site for both devotees and history enthusiasts."
    },
    {
      "title": "Ranjangaon MIDC Industrial Area",
      "description": "Ranjangaon is home to a major industrial hub developed by the Maharashtra Industrial Development Corporation (MIDC). The area hosts several multinational manufacturing companies, contributing significantly to the region's economy. While primarily industrial, the area reflects the blend of traditional and modern development in the region."
    },
    {
      "title": "Chondhe Farms Resort",
      "description": "Situated near Ranjangaon, Chondhe Farms Resort offers a rustic retreat with traditional Maharashtrian cuisine, outdoor activities, and serene surroundings. It's an ideal spot for family outings and day trips, providing a glimpse into rural life and hospitality."
    },
    {
      "title": "Nighoj Potholes",
      "description": "Approximately 35 km from Ranjangaon, the Nighoj Potholes are a geological wonder featuring naturally formed rock cavities created by the Kukadi River. These unique formations attract geologists and tourists alike, offering a fascinating natural spectacle."
    },
    {
      "title": "Meher Retreat",
      "description": "Located near Ranjangaon, Meher Retreat is an agro-tourism destination offering a blend of rural experiences, including farming activities, traditional food, and recreational facilities. It's a perfect getaway for those looking to experience the countryside."
    },
    {
      "title": "Lenyadri Ganpati Temple",
      "description": "Situated around 50 km from Ranjangaon, the Lenyadri Ganpati Temple is one of the Ashtavinayak temples and is unique for being located within a series of Buddhist caves. The temple is perched on a hill, requiring a climb of about 300 steps, and offers scenic views of the surrounding area."
    },
    {
      "title": "Shree Chintamani Temple, Theur",
      "description": "Approximately 40 km from Ranjangaon, this temple is another of the Ashtavinayak shrines dedicated to Lord Ganesha. The temple is known for its peaceful ambiance and historical significance, attracting devotees year-round."
    },
    {
      "title": "Alandi",
      "description": "Located about 60 km from Ranjangaon, Alandi is a significant pilgrimage site dedicated to Sant Dnyaneshwar, a revered Marathi saint. The town is known for its spiritual atmosphere and hosts numerous religious events and festivals."
    },
    {
      "title": "Bhigwan Bird Sanctuary",
      "description": "Approximately 70 km from Ranjangaon, Bhigwan is a paradise for bird watchers, especially during the winter months when migratory birds, including flamingos, flock to the area. The sanctuary offers boat rides and is a popular spot for nature photography."
    }
  ],
   "services": [
    {
      "name": "Cab & Bus Rentals for Corporates in Ranjangaon MIDC",
      "description": "eTravo provides reliable cab and bus rental services tailored for corporates in Ranjangaon MIDC. Our fleet includes air-conditioned cabs and buses suitable for daily employee commutes, business meetings, and corporate events. With flexible booking options and professional drivers, we ensure timely and comfortable transport solutions to meet your business requirements."
    },
    {
      "name": "Industrial Transport Solutions Ranjangaon",
      "description": "Specializing in industrial transport, eTravo offers customized shuttle and bus services for factories and manufacturing units in Ranjangaon. Our transport solutions cater to shift timings and large employee volumes, helping industries streamline workforce mobility while prioritizing safety and punctuality."
    },
    {
      "name": "Employee Commute Services in Ranjangaon MIDC",
      "description": "Ensure hassle-free daily commute for your employees with eTravo’s employee commute services in Ranjangaon MIDC. We provide scheduled buses and cabs covering major residential and industrial areas, enhancing employee satisfaction and reducing absenteeism through reliable, on-time transport."
    },
    {
      "name": "AC Buses and Cabs for Business Travel Ranjangaon",
      "description": "Travel in comfort with eTravo’s air-conditioned buses and cabs for business travel in Ranjangaon. Perfect for corporate outings, client meetings, and daily staff transport, our vehicles come equipped with modern amenities and are driven by experienced chauffeurs ensuring a smooth travel experience."
    },
    {
      "name": "Corporate Travel for MIDC Units in Ranjangaon",
      "description": "eTravo offers dedicated corporate travel services for MIDC units in Ranjangaon, including reliable shuttle services and long-distance business travel. Our transport plans are designed to meet the unique scheduling and volume needs of industrial zones, ensuring efficient staff movement and business continuity."
    },
    {
      "name": "Staff Transport Service in Ranjangaon MIDC",
      "description": "Providing dependable staff transport services in Ranjangaon MIDC, eTravo ensures that your workforce is safely transported between home and workplace. Our service emphasizes punctuality, comfort, and safety, helping businesses maintain operational efficiency and employee satisfaction."
    }
  ],
  "tableData": [
    ["Cab & Bus Rentals for Corporates in Ranjangaon MIDC", "Industrial Transport Solutions Ranjangaon"],
    ["Employee Commute Services in Ranjangaon MIDC", "AC Buses and Cabs for Business Travel Ranjangaon"],
    ["Corporate Travel for MIDC Units in Ranjangaon", "Staff Transport Service in Ranjangaon MIDC"]
  ],






"whychoose": [
    {
        "WhyChooseheading": "Reliable Transportation Partner for Ranjangaon MIDC",
        "WhyChoosedescription": "eTravo specializes in providing dependable corporate cab and bus services to companies in Ranjangaon MIDC—one of Maharashtra’s fastest-growing industrial zones. We support daily commutes, shift-based employee transport, and executive mobility with a focus on punctuality, safety, and professionalism."
    },
    {
        "WhyChooseheading": "Fleet Tailored for Industrial Operations",
        "WhyChoosedescription": "From well-maintained AC buses for large employee groups to premium sedans and SUVs for top-level executives, our fleet is equipped to meet the diverse transport needs of companies in Ranjangaon. Vehicles are spacious, clean, GPS-enabled, and designed for long-distance comfort."
    },
    {
        "WhyChooseheading": "Shift-Based Transport for 24/7 Industrial Operations",
        "WhyChoosedescription": "Ranjangaon MIDC operates across multiple shifts, and so do we. eTravo offers round-the-clock transport planning for all shift timings—early morning, late night, and weekend rotations. Our team ensures smooth coordination so your workforce is always on time and well taken care of."
    },
    {
        "WhyChooseheading": "Trained and Verified Drivers with Local Expertise",
        "WhyChoosedescription": "Our drivers are background-checked, uniformed, and trained in safe, courteous driving. They are highly familiar with the industrial zone’s entry points, internal roads, and nearby connectivity routes, ensuring efficient and hassle-free transit for employees and clients alike."
    },
    {
        "WhyChooseheading": "Transparent Pricing and Corporate Invoicing Support",
        "WhyChoosedescription": "With eTravo, you get clear, upfront pricing without any hidden costs. We offer GST-compliant invoicing, flexible billing cycles, and customized transport packages that fit your operational budget—ideal for both SMEs and large manufacturers operating in Ranjangaon."
    },
    {
        "WhyChooseheading": "Safety-First Approach with Well-Maintained Vehicles",
        "WhyChoosedescription": "All our cabs and buses are equipped with essential safety features—GPS tracking, fire extinguishers, first aid kits, seat belts, and emergency exits. Vehicles are sanitized regularly and undergo routine mechanical inspections to maintain high safety and hygiene standards."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Transport Coordination",
        "WhyChoosedescription": "Our backend operations team is available 24/7 to handle route changes, last-minute bookings, or emergency requests. With live ride tracking, real-time updates, and dedicated account managers, your company’s transport logistics stay organized and stress-free."
    },
    {
        "WhyChooseheading": "Custom Travel Solutions for Ranjangaon-Based Industries",
        "WhyChoosedescription": "Whether you need transport for 30 employees or 300, eTravo offers scalable and customizable transport solutions. From daily employee pickups and factory drop-offs to VIP visits and intercity transfers, we adapt to your business model and growth needs with flexibility and precision."
    }
]


































    }

// Corporate Cabs and Bus in Ranjangaon MIDC – eTravo

const faqData = [
    [
        {
            question: 'What corporate transport solutions does eTravo offer in Ranjangaon MIDC?',
            answer: 'eTravo provides comprehensive cab and bus services in Ranjangaon MIDC for industrial and corporate clients, covering daily employee commutes, executive travel, shift-based transport, and factory visits.',
        },
        {
            question: 'Can eTravo handle shift-based transportation for factories in Ranjangaon MIDC?',
            answer: 'Yes, we specialize in managing transport for 24/7 factory operations, offering precise shift scheduling, optimized routing, and on-time pickups and drops.',
        },
        {
            question: 'What types of vehicles are available for corporate use in Ranjangaon?',
            answer: 'Our fleet includes hatchbacks, sedans, SUVs, tempo travellers, and AC buses (13–50 seaters), all maintained to serve both employee groups and executive needs effectively.',
        },
        {
            question: 'Do the vehicles come with GPS tracking and safety monitoring?',
            answer: 'Yes, all vehicles are GPS-enabled, and we provide real-time tracking, driver verification, automated attendance logs, and compliance with corporate safety policies.',
        },
        {
            question: 'Is outstation or intercity transport available from Ranjangaon MIDC?',
            answer: 'Absolutely. We offer corporate travel services for intercity meetings, plant visits, vendor inspections, and business tours with full logistics support.',
        },
        {
            question: 'Will our company get dedicated support for transport services in Ranjangaon?',
            answer: 'Yes, each corporate client is assigned a dedicated account manager for daily coordination, route planning, troubleshooting, and performance reporting.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Ashish Bhore',
        designation: 'Admin Head, TechPolymer Pvt. Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“We’ve partnered with eTravo for our factory’s staff transportation in Ranjangaon. Their buses are clean, punctual, and well-managed. A reliable corporate solution.”',
    },
    {
        name: 'Ms. Pooja Kulkarni',
        designation: 'HR Manager, InduFlex Components',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has taken the headache out of our employee travel. Their service in Ranjangaon MIDC is efficient, scalable, and backed by great support.”',
    },
];












    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cabs and Bus in Ranjangaon MIDC",
  "image": "https://www.etravo.in/images/keyword/corporate-cabs-bus-ranjangaon-midc.jpg",
  "description": "Reliable corporate cab and bus rentals in Ranjangaon MIDC by eTravo. Perfect for industrial transport, employee commute, and staff shuttle services with air-conditioned vehicles and efficient corporate travel solutions.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cabs-and-bus-ranjangaon-midc"
  }
};




    return (
        <div>

<Helmet>
  <title>Corporate Cabs and Bus in Ranjangaon MIDC | Industrial & Employee Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus rentals in Ranjangaon MIDC with eTravo for industrial transport, employee commute, and staff shuttle services. Affordable and reliable AC vehicles available." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/21.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabandbusservicepuneranjangaon;